import { join } from "ramda";

import { Toastr } from "clearsense-ui/components";

export const showToastrError = error => {
  let message;
  const errorData = error?.error || error?.errors || error;
  if (typeof errorData === "string") {
    message = errorData;
  } else if (error?.errorCode === "E0000004") {
    message = "Invalid username/password.";
  } else if (typeof errorData === "object") {
    message = join("\n", errorData);
  } else if (errorData?.data && errorData?.data?.errors) {
    message = join("\n", errorData?.data?.errors);
  } else {
    message = "API endpoint error";
  }
  Toastr.error(message);
};
